import { useNavigate } from '@tanstack/react-router';
import { Button } from '../../components/ui/button';
import DashboardWrapper from '../../layout/DashboardWrapper';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <DashboardWrapper>
            <div className="flex flex-col items-center justify-center min-h-[50vh] p-4">
                <div className="bg-neutral-100 rounded-xl p-8 max-w-lg w-full text-center border border-neutral-200">
                    <div className="mb-6 flex justify-center">
                        <img
                            src="/undraw_page-not-found_6wni.svg"
                            alt="Page Not Found"
                            style={{ width: '50%', maxWidth: '400px' }}
                        />
                    </div>
                    <h2 className="text-2xl font-semibold text-primary mb-2">Page Not Found</h2>
                    <p className="text-lg text-neutral-700 mb-6">
                        Sorry, the page you are looking for does not exist or has been moved.
                    </p>
                    <Button
                        variant="destructive"
                        className="rounded-lg font-semibold transition-all duration-200 transform hover:scale-105"
                        onClick={() => navigate({ to: '/dashboard' })}
                    >
                        Return to Dashboard
                    </Button>
                </div>
            </div>
        </DashboardWrapper>
    );
};

export default NotFound;
